// OpenAI Realtime server-event type strings received over the browser's own
// WebRTC data channel ("oai-events") - NOT our backend's /voice/events
// sideband, which only carries the guarded AlphaChatEvent turn. The browser
// is itself a participant in the realtime session, so it gets these directly.
//
// RESPONSE_CREATED/DONE and the two ASSISTANT_TRANSCRIPT names are cross-
// checked against eb's independent GA research (developers.openai.com/api/
// docs/guides/realtime + the realtime-client-events/realtime-server-events
// reference pages, 2026-10-06) - response.audio_transcript.* was the beta
// name, GA renamed it response.output_audio_transcript.*. SPEECH_STARTED/
// STOPPED are confirmed unchanged (f5). OUTPUT_AUDIO_STARTED/STOPPED and
// both USER_TRANSCRIPT_* names are UNCONFIRMED - absent from eb's server-
// events list, which may mean they don't exist under these names in GA, or
// just that their pass didn't need them. A wrong name here degrades
// gracefully (the speaking indicator or live user-transcript bubble just
// never fires) rather than breaking anything - verify at build/integration
// time against a live session.
export const OAI_REALTIME_EVENT = {
  RESPONSE_CREATED: 'response.created',
  RESPONSE_DONE: 'response.done',
  SPEECH_STARTED: 'input_audio_buffer.speech_started',
  SPEECH_STOPPED: 'input_audio_buffer.speech_stopped',
  OUTPUT_AUDIO_STARTED: 'output_audio_buffer.started',
  OUTPUT_AUDIO_STOPPED: 'output_audio_buffer.stopped',
  OUTPUT_AUDIO_CLEARED: 'output_audio_buffer.cleared',
  USER_TRANSCRIPT_DELTA: 'conversation.item.input_audio_transcription.delta',
  USER_TRANSCRIPT_DONE: 'conversation.item.input_audio_transcription.completed',
  ASSISTANT_TRANSCRIPT_DELTA: 'response.output_audio_transcript.delta',
  ASSISTANT_TRANSCRIPT_DONE: 'response.output_audio_transcript.done',
} as const;

export interface IOaiRealtimeEvent {
  type: string;
  item_id?: string;
  delta?: string;
  transcript?: string;
  name?: string;
  item?: { type?: string; name?: string };
}

export function parseOaiRealtimeMessage (raw: string): IOaiRealtimeEvent | null {
  try {
    const parsed = JSON.parse(raw) as IOaiRealtimeEvent;
    return typeof parsed?.type === 'string' ? parsed : null;
  } catch {
    return null;
  }
}

export const buildClearMessage = (): string =>
  JSON.stringify({ type: 'output_audio_buffer.clear' });
